/**
 * Compile-time literal union of all valid Task field IDs.
 *
 * Derived from the field maps in `./fields/*.ts` (wrapped in `defineFieldConfigMap`).
 * Used to narrow `SavedViewConfig.visibleColumns` so typos in saved views
 * are caught by `tsc`.
 */
import { TASK_CORE_FIELDS } from "./fields/task-core-fields";
import { TASK_STATUS_SCHEDULE_FIELDS } from "./fields/task-status-schedule-fields";

export const TASK_FIELDS = {
  ...TASK_CORE_FIELDS,
  ...TASK_STATUS_SCHEDULE_FIELDS,
};

/** Literal union of every valid task field id. */
export type TaskFieldId = keyof typeof TASK_FIELDS;
